import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiResponse} from '../classes/api-response';
import {Constants} from '../utils/constants';
import {map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {OptionValueCreate, OptionValueData} from "../interfaces/option-value";
import {FetchParams, PageConverter} from "../utils/global-functions-and-types";


@Injectable({
  providedIn: 'root'
})
export class OptionValuesService {

  constructor(private http: HttpClient) { }

  private readonly crtlFullPath = `${environment.apiUrl}/${Constants.entities.companies}`;

  public getAllOptionValues(companyId: number, optionId: number, paginationParams?: FetchParams): Observable<PageConverter<OptionValueData>> {

    let sortFilterParams = new HttpParams({fromObject: {...paginationParams}})

    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${companyId}/${Constants.entities.options}/${optionId}/values`, {params: sortFilterParams})
      .pipe(map(value => value.data as PageConverter<OptionValueData>))

  }
  public getOptionValue(companyId: number, optionId: number, valueId: number): Observable<OptionValueData> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${companyId}/${Constants.entities.options}/${optionId}/values/${valueId}`)
      .pipe(map(value => value.data as OptionValueData))

  }

  public createOptionValue(companyId: number, optionId: number, value: OptionValueCreate): Observable<OptionValueData> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}/${companyId}/${Constants.entities.options}/${optionId}/values`, value)
      .pipe(map(value => value.data as OptionValueData));
  }


  public updateOptionValue(companyId: number, optionId: number, valueId: number, value: OptionValueCreate): Observable<OptionValueData> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${companyId}/${Constants.entities.options}/${optionId}/values/${valueId}`,value)
      .pipe(map(value => value.data as OptionValueData))
  }

  public deleteOptionValue(companyId: number, optionId: number, valueId: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${companyId}/${Constants.entities.options}/${optionId}/values/${valueId}`)
      .pipe(map(() => {
      }))
  }
}
